import { createGeneralVideoProvider } from '../general';
import { minimaxConfigs } from './configs/minimax';

/**
 * GRSAI 视频提供商，与图像侧共用 GRSAI_BASE_URL / GRSAI_API_KEY。
 *
 * - 提交：POST /v1/api/generate，replyType=async
 * - 查询：GET /v1/api/result?id={id}
 * 状态：running / succeeded / failed / violation
 */
export const grsai = createGeneralVideoProvider({
    providerName: 'GRSAI',
    baseUrlEnv: 'GRSAI_BASE_URL',
    apiKeyEnv: 'GRSAI_API_KEY',
    debugEnv: 'GRSAI_DEBUG',
    statusMapping: {
        taskIdPath: 'id',
        statePath: 'status',
        success: ['succeeded'],
        failed: ['failed', 'violation'],
        processing: ['running'],
        videoUrlPath: 'results[0].url',
        errorPath: 'error',
    },
    models: {
        ...minimaxConfigs,
    },
});